import { GeneralConfirmModalProps } from '@mm/state/modules/modalsState/props';
import classnames from 'classnames';
import React, { useEffect } from 'react';
import { ButtonColor } from '../../buttons/PrimaryButton/PrimaryButton';
import {
  CloseModalProps,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../modal-helpers';
import './GeneralConfirmModal.pcss';
import { Button } from '@mm/components';

type Props = GeneralConfirmModalProps & CloseModalProps;

const GeneralConfirmModal = (props: Props) => {
  const {
    closeModal,
    messageText,
    headerText,
    onCloseHandler,
    onOpenHandler,
    cancelButtonFirst,
    showHeader = true,
    secondLineText,
    showCancelButton = true,
    cancelButtonColor,
    modalClassname,
    css,
  } = props;

  useEffect(() => {
    if (onOpenHandler) {
      onOpenHandler();
    }
  }, []);

  const okButtonText = props.okButtonText || 'Ok';
  const cancelButtonText = props.cancelButtonText || 'Cancel';
  const okButtonStyling = props.okButtonStyling || { red: true };

  const okButtonColor = okButtonStyling.red
    ? ButtonColor.red
    : okButtonStyling.gray
    ? ButtonColor.gray
    : ButtonColor.blue;

  const onClose = (ok: boolean) => {
    closeModal();
    onCloseHandler(ok);
  };

  const cancelButton = () => (
    <Button
      css={{
        container: classnames(
          'general-confirm-modal__button',
          css?.secondaryButton,
        ),
      }}
      color={cancelButtonColor || ButtonColor.gray}
      onClick={() => onClose(false)}
    >
      {cancelButtonText}
    </Button>
  );
  const classname = classnames('general-confirm-modal', modalClassname);

  return (
    <div className={classname}>
      {showHeader && (
        <ModalHeader
          newStyle
          closeOverride={() => onClose(false)}
          className={classnames('general-confirm-modal__header', css?.header)}
        >
          <p className="general-confirm-modal__header-text">{headerText}</p>
        </ModalHeader>
      )}

      <ModalBody
        className={classnames('general-confirm-modal__body', css?.body)}
      >
        <p>{messageText}</p>
        {secondLineText && <p>{secondLineText}</p>}
      </ModalBody>

      <ModalFooter
        className={classnames('general-confirm-modal__footer', css?.footer)}
      >
        {showCancelButton && !!cancelButtonFirst && cancelButton()}
        <Button
          color={okButtonColor}
          css={{
            container: classnames(
              'general-confirm-modal__button',
              css?.primaryButton,
            ),
          }}
          onClick={() => onClose(true)}
        >
          {okButtonText}
        </Button>
        {showCancelButton && !cancelButtonFirst && cancelButton()}
      </ModalFooter>
    </div>
  );
};

export default GeneralConfirmModal;
